module.exports = __webpack_public_path__ + "stylesheets/section-company-info_357a5473346683d9219dc4ee0d3e8e89.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/sections/section-company-info.less
// module id = b+CF
// module chunks = 154